import { types } from '../types'

export const loginUser = (params) => {
    return {
        type: types.LOGIN_USER_REQUEST,
        params,
    }
}



export const registerUser = (params) => {
    return {
        type: types.REGISTER_USER_REQUEST,
        params,
    }
}


export const getCareerField = () => {
    return {
        type: types.GET_CAREER_FIELD_REQUEST,

    }
}

export const checkExistEmail = (params) => {

    return {
        type: types.CHECK_EMAIL_EXIST_REQUEST,
        params

    }
}


export const captchaVerified = (params) => {
    return {
        type: types.CHECK_EMAIL_EXIST_REQUEST,
        params

    }
}

export const sendResetPasswordEmail = (params) => {
    return {
        type: types.SEND_RESET_PASSWORD_EMAIL_REQUEST,
        params

    }
}

export const sendResetPasswordEmailReset = () => {
    return {
        type: types.SEND_RESET_PASSWORD_EMAIL_RESET_PROPS,


    }
}

export const resetLoginProps = () => {
    return {
        type: types.LOGIN_USER_RESET_PROPS,


    }
}

export const resetIsExistEmailProps = () => {
    return {
        type: types.RESET_IS_EXIST_EMAIL_PROPS,


    }
}